import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Magnetism } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * The magnetometer sensor provides information about the magnetic field as detected by the device's primary magnetometer sensor.
 * @category data
 */
let Magnetometer = class Magnetometer extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Magnetism(), frequency, displayName);
  }
};
Magnetometer = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Magnetism, Number, String])], Magnetometer);
export { Magnetometer };